import $ from 'jquery';

import BasePasswordField from 'registration/js/base/fields/password';
import pushGaEventNew, { GTM_EVENTS } from 'registration/js/lib/googletagmanager/new_events';
import { getPasswordFlow } from 'registration/js/lib/get_field_flow';
import { _ } from 'wgnet-awesomejs';
import mobile from 'wgnet-awesomejs/lib/mobile';

import template from 'registration/templates/dark/fields/password.html';

const PasswordField = BasePasswordField.extend({
    template,
    isMTForm: _.extract('Settings.Registration.gameModificatorIsWot', false),
    afterInitialize() {
        // TODO: need refactor: it'sthe same as dark/signin_fields/password.js
        const $passwordField = this.$('input');
        const $passwordFieldWrapper = $passwordField.parent();
        const $passwordFieldSet = $passwordField.parents('fieldset');
        const $passwordEye = $('.js-password-eye', $passwordFieldSet);
        const passwordEyeBemBlock = $passwordEye.data('bem-block');
        const passwordEyeWrModifierShow = $passwordEye.data('bem-wrapper-modifier-show');
        const passwordEyeModifierShow = $passwordEye.data('bem-modifier-show');
        const passwordEyeShowClass = `${passwordEyeBemBlock}__${passwordEyeModifierShow}`;

        if (this.isMTForm) {
            $passwordFieldWrapper.addClass(passwordEyeWrModifierShow);
            $passwordEye.removeClass('hidden');

            const passwordFlow = getPasswordFlow();
            if (passwordFlow === 'no_repeat') {
                $passwordFieldSet.removeClass('form-fieldgroup__indent-5').addClass('form-fieldgroup__indent-30');
            } else {
                $passwordFieldSet.removeClass('form-fieldgroup__indent-30').addClass('form-fieldgroup__indent-5');
            }
        } else if (mobile().useMobile) {
            $passwordFieldWrapper.addClass(passwordEyeWrModifierShow);
            $passwordEye.removeClass('hidden');
        }

        $passwordEye.on('click', _.bind(() => {
            const currentType = $passwordField.attr('type');
            const isPasswordHidden = currentType === 'password';
            const changeType = isPasswordHidden ? 'text' : 'password';
            const eventType = isPasswordHidden ? 'show' : 'hide';

            pushGaEventNew({ event: GTM_EVENTS.PASSWORD_FIELD_STATE_CHANGE[eventType] });

            $passwordEye.toggleClass(passwordEyeShowClass);
            $passwordField.attr('type', changeType);

            // After changing field type, we must manually set focus to the last character
            const hasValue = $passwordField.val() !== '';
            if (hasValue) {
                const element = $passwordField[0];

                if (element.selectionStart || element.selectionStart === 0) {
                    const valueLength = element.value.length;

                    element.selectionStart = valueLength;
                    element.selectionEnd = valueLength;
                }
            }

            $passwordField.focus();
        }, this));
    },
});

export default PasswordField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/password.js